import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import RobitoLogo from "../components/RobitoLogo";
import { apiPostPublic } from "../utils/api";

function Dashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = async () => {
    try {
      const response = await apiPostPublic("logout.php");
      if (response.status === 'success') {
        navigate("/login");
      }
    } catch (error) {
      alert("Oops, something went wrong");
    }
  };

  const navItems = [
    { path: "/dashboard/google-play-review", label: "Google Play Review" },
    { path: "/dashboard/app-store-review", label: "App Store Review" },
    { path: "/dashboard/billing-payment", label: "Billing & Payments" },
    { path: "/dashboard/account-settings", label: "Account Settings" },
    { path: "/dashboard/referral", label: "Referral" },
    { path: "/help-faq", label: "Help & FAQ", external: true }, // Marked as external
    { path: "/privacy-policy", label: "Privacy Policy", external: true },
    { path: "/terms-of-service", label: "Terms of Service", external: true },
  ];

  return (
    <div className="dashboard-container" style={{ display: "flex", height: "100vh" }}>
      {/* Sidebar */}
      <nav
        className="dashboard-sidebar"
        style={{
          width: "260px",
          backgroundColor: "#f2f6fc",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "20px",
          borderRight: "1px solid #e0e0e0",
        }}
      >
        <div>
          <RobitoLogo />
          <ul style={{ listStyle: "none", padding: 0, marginTop: "30px" }}>
            {navItems.map((item) => {
              const active =
                location.pathname === item.path ||
                ((location.pathname === "/dashboard" || location.pathname === "/dashboard/") &&
                  item.path === "/dashboard/google-play-review");

              return (
                <li key={item.path} style={{ marginBottom: "10px" }}>
                  {item.external ? (
                    <a
                      href={item.path}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="nav-button"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        borderRadius: "6px",
                        textDecoration: "none",
                        backgroundColor: "transparent",
                        color: "#2563eb",
                        fontWeight: "500",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {item.label}
                    </a>
                  ) : (
                    <Link
                      to={item.path}
                      className="nav-button"
                      style={{
                        display: "block",
                        padding: "10px 15px",
                        borderRadius: "6px",
                        textDecoration: "none",
                        backgroundColor: active ? "#2563eb" : "transparent",
                        color: active ? "#fff" : "#2563eb",
                        fontWeight: "500",
                        transition: "all 0.2s ease",
                      }}
                    >
                      {item.label}
                    </Link>
                  )}
                </li>
              );
            })}
            <li>
              <button
                onClick={handleLogout}
                className="nav-button logout-button"
                style={{
                  display: "block",
                  padding: "10px 15px",
                  borderRadius: "6px",
                  border: "none",
                  backgroundColor: "#e53e3e",
                  color: "#fff",
                  cursor: "pointer",
                  fontWeight: "500",
                  width: "100%",
                  transition: "background 0.2s ease",
                }}
              >
                Logout
              </button>
            </li>
          </ul>
        </div>
        <div className="copyright" style={{ textAlign: "center", fontSize: "0.8rem", color: "#666" }}>
          © Robito.Ai 2026
        </div>
      </nav>

      {/* Content */}
      <main style={{ flex: 1, padding: "20px", overflowY: "auto" }}>
        <Outlet />
      </main>
    </div>
  );
}

export default Dashboard;
